import { IVenueFormValues } from 'FormPage/FormPage'
import { IRoom, IPhoto } from 'utils'

export const changeMealIntoString = (
  rooms: IRoom[],
  isEntireHouse?: boolean
) => {
  return rooms.map((room) => {
    const copiedRoom = { ...room }

    if (copiedRoom.thumbnail) {
      //@ts-ignore
      delete copiedRoom.thumbnail
    }
    delete copiedRoom.photos

    return {
      ...copiedRoom,
      variations: !isEntireHouse
        ? [
            ...room.variations.map((variation) => ({
              ...variation,
              meal: (variation.meal as { label: string })?.label,
            })),
          ]
        : undefined,
    }
  })
}

export const isNumber = (n: number | null | undefined) => n && !isNaN(n)

export const getAllImages = (values: IVenueFormValues) => {
  const photos: IPhoto[] = [{ isHero: true, file: values.thumbnail as File }]

  ;(values.photos as { file: File }[]).forEach(({ file }: { file: File }) =>
    photos.push({ file })
  )
  ;(values.rooms as IRoom[])?.forEach((room: IRoom, index: number) => {
    photos.push({ roomIndex: index, file: room.thumbnail, isHero: true })
    if (room.photos?.length) {
      room.photos.forEach(({ file }) => {
        photos.push({ roomIndex: index, file })
      })
    }
  })

  if (values.additionalInfo.hasMeetingRooms)
    (values.meetingRooms as IRoom[])?.forEach((room: IRoom, index: number) => {
      photos.push({
        roomIndex: index,
        file: room.thumbnail,
        isHero: true,
        isMeetingRoom: true,
      })
      if (room.photos?.length) {
        room.photos.forEach(({ file }) => {
          photos.push({ roomIndex: index, file, isMeetingRoom: true })
        })
      }
    })

  return photos
}
